export interface IRegions {
    name: string
    districts: IDistricts[]
}

export interface IDistricts {
    name: string
    municipals: string[]
}

// export const regions: IRegions[] = [
//     {
//         name: "Arusha",
//         districts: [
//             { name: "Arusha", municipals: ["Arusha Jiji"] },
//             { name: "Arumeru", municipals: ["Arusha DC", "Meru DC"] },
//             { name: "Ngorongoro", municipals: ["Ngorongoro DC"] },
//             { name: "Longido", municipals: ["Longido DC"] },
//             { name: "Monduli", municipals: ["Monduli DC"] },
//             { name: "Karatu", municipals: ["Karatu DC"] }
//         ]
//     },
//     {
//         name: "Dar es Salaam",
//         districts: [
//             { name: "Kinondoni", municipals: ["Kinondoni MC"] },
//             { name: "Ilala", municipals: ["Dar es Salaam Jiji", "Ilala MC"] },
//             { name: "Temeke", municipals: ["Temeke MC"] },
//             { name: "Kigamboni", municipals: ["Kigamboni MC"] },
//             { name: "Ubungo", municipals: ["Ubungo MC"] }
//         ]
//     },
//     {
//         name: "Dodoma",
//         districts: [
//             { name: "Chamwino", municipals: ["Chamwino DC"] },
//             { name: "Dodoma", municipals: ["Dodoma Jiji"] },
//             { name: "Chemba", municipals: ["Chemba DC"] },
//             { name: "Kondoa", municipals: ["Kondoa DC", "Kondoa Mji"] },
//             { name: "Bahi", municipals: ["Bahi DC"] },
//             { name: "Mpwapwa", municipals: ["Mpwapwa DC"] },
//             { name: "Kongwa", municipals: ["Kongwa DC"] }
//         ]
//     },
//     {
//         name: "Geita",
//         districts: [
//             { name: "Bukombe", municipals: ["Bukombe DC"] },
//             { name: "Mbogwe", municipals: ["Mbogwe DC"] },
//             { name: "Nyangwale", municipals: ["Nyangwale DC"] },
//             { name: "Geita", municipals: ["Geita DC", "Geita Mji"] },
//             { name: "Chato", municipals: ["Chato DC"] }
//         ]
//     },
//     {
//         name: "Iringa",
//         districts: [
//             { name: "Mufindi", municipals: ["Mufindi DC", "Mafinga Mji"] },
//             { name: "Kilolo", municipals: ["Kilolo DC"] },
//             { name: "Iringa", municipals: ["Iringa DC", "Iringa MC"] }
//         ]
//     },
//     {
//         name: "Kagera",
//         districts: [
//             { name: "Biharamulo", municipals: ["Biharamulo DC"] },
//             { name: "Karagwe", municipals: ["Karagwe DC"] },
//             { name: "Muleba", municipals: ["Muleba DC"] },
//             { name: "Kyerwa", municipals: ["Kyerwa DC"] },
//             { name: "Bukoba", municipals: ["Bukoba DC", "Bukoba MC"] },
//             { name: "Ngara", municipals: ["Ngara DC"] },
//             { name: "Missenyi", municipals: ["Missenyi DC"] }
//         ]
//     },
//     {
//         name: "Katavi",
//         districts: [
//             { name: "Mlele", municipals: ["Mlele DC", "Mpimbwe DC"] },
//             { name: "Mpanda", municipals: ["Mpanda MC", "Nsimbo DC"] },
//             { name: "Tanganyika", municipals: ["Mpanda DC"] }
//         ]
//     },
//     {
//         name: "Kigoma",
//         districts: [
//             { name: "Kigoma", municipals: ["Kigoma DC", "Kigoma/Ujiji MC"] },
//             { name: "Kasulu", municipals: ["Kasulu DC", "Kasulu TC"] },
//             { name: "Kakonko", municipals: ["Kakonko DC"] },
//             { name: "Uvinza", municipals: ["Uvinza DC"] },
//             { name: "Buhigwe", municipals: ["Buhigwe DC"] },
//             { name: "Kibondo", municipals: ["Kibondo DC"] }
//         ]
//     },
//     {
//         name: "Kilimanjaro",
//         districts: [
//             { name: "Siha", municipals: ["Siha DC"] },
//             { name: "Moshi", municipals: ["Moshi MC", "Moshi DC"] },
//             { name: "Mwanga", municipals: ["Mwanga DC"] },
//             { name: "Rombo", municipals: ["Rombo DC"] },
//             { name: "Hai", municipals: ["Hai DC"] },
//             { name: "Same", municipals: ["Same DC"] }
//         ]
//     },
//     {
//         name: "Lindi",
//         districts: [
//             { name: "Nachingwea", municipals: ["Nachingwea DC"] },
//             { name: "Ruangwa", municipals: ["Ruangwa DC"] },
//             { name: "Liwale", municipals: ["Liwale DC"] },
//             { name: "Lindi", municipals: ["Lindi MC", "Lindi DC"] },
//             { name: "Kilwa", municipals: ["Kilwa DC"] }
//         ]
//     },
//     {
//         name: "Manyara",
//         districts: [
//             { name: "Babati", municipals: ["Babati TC", "Babati DC"] },
//             { name: "Mbulu", municipals: ["Mbulu DC", "Mbulu Mji"] },
//             { name: "Hanang", municipals: ["Hanang DC"] },
//             { name: "Kiteto", municipals: ["Kiteto DC"] },
//             { name: "Simanjiro", municipals: ["Simanjiro DC"] }
//         ]
//     },
//     {
//         name: "Mara",
//         districts: [
//             { name: "Rorya", municipals: ["Rorya DC"] },
//             { name: "Serengeti", municipals: ["Serengeti DC"] },
//             { name: "Bunda", municipals: ["Bunda DC", "Bunda Mji"] },
//             { name: "Butiama", municipals: ["Butiama DC"] },
//             { name: "Tarime", municipals: ["Tarime DC", "Tarime Mji"] },
//             { name: "Musoma", municipals: ["Musoma MC", "Musoma DC"] }
//         ]
//     },
//     {
//         name: "Mbeya",
//         districts: [
//             { name: "Chunya", municipals: ["Chunya DC"] },
//             { name: "Kyela", municipals: ["Kyela DC"] },
//             { name: "Mbeya", municipals: ["Mbeya DC", "Mbeya Jiji"] },
//             { name: "Rungwe", municipals: ["Rungwe DC", "Busokelo DC"] },
//             { name: "Mbarali", municipals: ["Mbarali DC"] }
//         ]
//     },
//     {
//         name: "Morogoro",
//         districts: [
//             { name: "Gairo", municipals: ["Gairo DC"] },
//             { name: "Kilombero", municipals: ["Kilombero DC", "Ifakara Mji"] },
//             { name: "Mvomero", municipals: ["Mvomero DC"] },
//             { name: "Morogoro", municipals: ["Morogoro DC", "Morogoro MC"] },
//             { name: "Ulanga", municipals: ["Ulanga DC"] },
//             { name: "Kilosa", municipals: ["Kilosa DC"] },
//             { name: "Malinyi", municipals: ["Malinyi DC"] }
//         ]
//     },
//     {
//         name: "Mtwara",
//         districts: [
//             { name: "Newala", municipals: ["Newala DC", "Newala TC"] },
//             { name: "Nanyumbu", municipals: ["Nanyumbu DC"] },
//             { name: "Mtwara", municipals: ["Mtwara MC", "Mtwara DC", "Nanyamba Mji"] },
//             { name: "Masasi", municipals: ["Masasi DC", "Masasi Mji"] },
//             { name: "Tandahimba", municipals: ["Tandahimba DC"] }
//         ]
//     },
//     {
//         name: "Mwanza",
//         districts: [
//             { name: "Ilemema", municipals: ["Ilemela DC"] },
//             { name: "Kwimba", municipals: ["Kwimba DC"] },
//             { name: "Sengerema", municipals: ["Sengerema DC", "Buchosa DC"] },
//             { name: "Nyamagana", municipals: ["Mwanza Jiji"] },
//             { name: "Magu", municipals: ["Magu DC"] },
//             { name: "Ukerewe", municipals: ["Ukerewe DC"] },
//             { name: "Misungwi", municipals: ["Misungwi DC"] }
//         ]
//     },
//     {
//         name: "Njombe",
//         districts: [
//             { name: "Njombe", municipals: ["Njombe DC", "Njombe Mji", "Makambako Mji"] },
//             { name: "Ludewa", municipals: ["Ludewa DC"] },
//             { name: "Wangingombe", municipals: ["Wangingombe DC"] },
//             { name: "Makete", municipals: ["Makete DC"] }
//         ]
//     },
//     {
//         name: "Pwani",
//         districts: [
//             { name: "Bagamoyo", municipals: ["Arusha Jiji"] }, // check
//             { name: "Mkuranga", municipals: ["Arusha DC", "Meru DC"] }, // check
//             { name: "Rufiji", municipals: ["Ngorongoro DC"] }, // check
//             { name: "Mafia", municipals: ["Makete DC"] }, // check
//             { name: "Kibaha", municipals: ["Kibaha DC", "Kibaha Mji"] },
//             { name: "Kisarawe", municipals: ["Kisarawe DC"] },
//             { name: "Kibiti", municipals: ["Kibiti DC"] }
//         ]
//     },
//     {
//         name: "Rukwa",
//         districts: [
//             { name: "Sumbawanga", municipals: ["Sumbawanga DC", "Sumbawanga MC"] },
//             { name: "Nkasi", municipals: ["Nkasi DC"] },
//             { name: "Kalambo", municipals: ["Kalambo DC"] }
//         ]
//     },
//     {
//         name: "Ruvuma",
//         districts: [
//             { name: "Namtumbo", municipals: ["Namtumbo DC"] },
//             { name: "Mbinga", municipals: ["Mbinga DC", "Mbinga Mji"] },
//             { name: "Nyasa", municipals: ["Nyasa DC"] },
//             { name: "Tunduru", municipals: ["Tunduru DC"] },
//             { name: "Songea", municipals: ["Songea MC", "Madaba DC", "Songea DC"] }
//         ]
//     },
//     {
//         name: "Shinyanga",
//         districts: [
//             { name: "Kishapu", municipals: ["Kishapu DC"] },
//             { name: "Kahama", municipals: ["Kahama Mji", "Ushetu DC", "Msalala DC"] },
//             { name: "Shinyanga", municipals: ["Shinyanga MC", "Shinyanga DC"] }
//         ]
//     },
//     {
//         name: "Simiyu",
//         districts: [
//             { name: "Mkalama", municipals: ["Mkalama DC"] },
//             { name: "Manyoni", municipals: ["Manyoni DC", "Itigi DC"] },
//             { name: "Singida", municipals: ["Singida MC", "Singida DC"] },
//             { name: "Ikungi", municipals: ["Ikungi DC"] },
//             { name: "Iramba", municipals: ["Iramba DC"] }
//         ]
//     },
//     {
//         name: "Songwe",
//         districts: [
//             { name: "Songwe", municipals: ["Songwe DC"] },
//             { name: "Ileje", municipals: ["Ileje DC"] },
//             { name: "Mbozi", municipals: ["Mbozi DC"] },
//             { name: "Momba", municipals: ["Tunduma Mji", "Momba DC"] }
//         ]
//     },
//     {
//         name: "Tabora",
//         districts: [
//             { name: "Nzega", municipals: ["Nzega DC", "Nzega Mji"] },
//             { name: "Kaliua", municipals: ["Kaliua DC"] },
//             { name: "Igunga", municipals: ["Igunga DC"] },
//             { name: "Sikonge", municipals: ["Sikonge DC"] },
//             { name: "Tabora", municipals: ["Tabora MC"] },
//             { name: "Urambo", municipals: ["Urambo DC"] },
//             { name: "Uyui", municipals: ["Tabora/Uyui DC"] }
//         ]
//     },
//     {
//         name: "Tanga",
//         districts: [
//             { name: "Tanga", municipals: ["Arusha Jiji"] }, // check
//             { name: "Muheza", municipals: ["Arusha DC", "Meru DC"] }, // check
//             { name: "Mkinga", municipals: ["Ngorongoro DC"] }, // check
//             { name: "Pangani", municipals: ["Longido DC"] }, // check
//             { name: "Handeni", municipals: ["Handeni Mji", "Handeni DC"] },
//             { name: "Korogwe", municipals: ["Korogwe Mji", "Korogwe DC"] },
//             { name: "Kilindi", municipals: ["Kilindi DC"] },
//             { name: "Lushoto", municipals: ["Lushoto DC", "Bumbuli DC"] }
//         ]
//     },
//     {
//         name: "Zanzibar",
//         districts: [
//             { name: "Zanzibar", municipals: ["Zanzibar DC", "Zanzibar Mji"] },
//
//         ]
//     }
// ]

export interface IRegions {
    name: string
    districts: IDistricts[]
}

export interface IDistricts {
    name: string
    municipals: string[]
}

export const regions: IRegions[] = [
    {
        name: "Mjini Magharibi Region",
        districts: [
            {
                name: "Magharibi A Municipal",
                municipals: [
                    "Bububu", "Bumbwisudi", "Chemchem", "Chuini", "Dole",
                    "Hawaii", "Kama", "Kianga", "Kibweni", "Kihinani",
                    "Kijichi", "Kikaangoni", "Kizimbani", "Kwa Goa", "Masingini",
                    "Mbuzini", "Mfenesini", "Michikichini", "Mtoni", "Mtoni ChemChem",
                    "Mtoni Kidatu", "Mto Pepo", "Mtufaani", "Muembe Mchomeke", "Munduli",
                    "Mwakaje", "Mwanyanya", "Mwera", "Sharifu Msa", "Uholanzi", "Welezo"
                ]
            },
            {
                name: "Magharibi B Municipal",
                municipals: [
                    "Bweleo", "Chukwani", "Chunga", "Dimani", "Fumba",
                    "Fuoni Kibondeni", "Fuoni Kijito Upele", "Fuoni Kipungani", "Fuoni Migombani",
                    "Jitimai", "Kiembesamaki", "Kinuni", "Kisauni", "Kombeni", "Kwa Mchina",
                    "Magogoni", "Mambosasa", "Maungani", "Mbweni", "Meli Nne",
                    "Michungwani", "Mikarafuuni", "Mnarani", "Mombasa", "Muembe Majogoo",
                    "Mwanakwerekwe", "Nyamanzi", "Pangawe", "Shakani", "Sokoni",
                    "Taveta", "Tomondo", "Uwandani", "Uzi"
                ]
            },
            {
                name: "Mjini Municipal",
                municipals: [
                    "Amani", "Banko", "Chumbuni", "Gulioni", "Jang'ombe",
                    "Karakana", "Kidongo Chekundu", "Kikwajuni Bondeni", "Kikwajuni Juu",
                    "Kilimahewa Bondeni", "Kilimahewa Juu", "Kilimani", "Kiponda",
                    "Kisima Majongoo", "Kisiwandui", "Kwaalimsha", "Kwaalinatu",
                    "Kwabintiamrani", "Kwahani", "Kwamtipura", "Kwamtumwajeni",
                    "Kwa Wazee", "Magomeni", "Makadara", "Malindi", "Mapinduzi",
                    "Maruhubi", "Masumbani", "Matarumbeta", "Mboriborini", "Mchangani",
                    "Meya", "Miembeni", "Migombani", "Mikunguni", "Mitiulaya",
                    "Mkele", "Mkunazini", "Mlandege", "Mnazimmoja", "Mpendae",
                    "Muungano", "Mwembeladu", "MwembeMadema", "Mwembe Makumbi",
                    "Mwembeshauri", "Mwembetanga", "Nyerere", "Rahaleo", "Saateni",
                    "Sebleni", "Shangani", "Shaurimoyo", "Sogea", "Urusi",
                    "Vikokotoni"
                ]
            }
        ]
    },
    {
        name: "Pemba North Region",
        districts: [
            {
                name: "Micheweni District",
                municipals: [
                    "Chamboni", "Chimba", "Kifundi", "Kinowe", "Kipange",
                    "Kiuyu Mbuyuni", "Konde", "Majenzi", "Makangale", "Maziwa Ng'ombe",
                    "Micheweni", "Mihogoni", "Mjini Wingwi", "Msuka Magharibi",
                    "Msuka Mashariki", "Mtemani", "Shanake", "Shumba Mjini",
                    "Shumba Viamboni", "Sizini", "Tondooni", "Tumbe Magharibi",
                    "Tumbe Mashariki", "Wingwi Mapofu", "Wingwi Njuguni"
                ]
            },
            {
                name: "Wete District",
                municipals: [
                    "Bopwe", "Chwale", "Finya", "Fundo", "Gando", "Jadida",
                    "Junguni", "Kambini", "Kangagani", "Kinyasini", "Kinyikani",
                    "Kipangani", "Kisiwani", "Kiungoni", "Kiuyu Kigongoni",
                    "Kiuyu Minungwini", "Kizimbani", "Kojani", "Limbani", "Maziwani",
                    "Mchanga Mdogo", "Mgogoni", "Mjananza", "Mlindo", "Mpambani",
                    "Mtambwe Kaskazini", "Mtambwe Kusini", "Mtemani", "Mzambarauni Takao",
                    "Pandani", "Pembeni", "Piki", "Selem", "Shengejuu", "Ukunjwi",
                    "Utaani"
                ]
            }
        ]
    },
    {
        name: "Pemba South Region",
        districts: [
            {
                name: "Mkoani District",
                municipals: [
                    "Chambani", "Changaweni", "Chokocho", "Chole", "Chumbageni",
                    "Dodo", "Jombwe", "Kangani", "Kendwa", "Kengeja", "Kisiwa Panza",
                    "Kiwani", "Kuukuu", "Makombeni", "Makoongwe", "Mbuguani",
                    "Mbuyuni", "Mchakwe", "Mgagadu", "Michenzani", "Minazini",
                    "Mizingani", "Mjimbini", "Mkanyageni", "Mkungu", "Mtambile",
                    "Mtangani", "Muambe", "Ng'ombeni", "Ngwachani", "Shamiani",
                    "Shidi", "Stahabu", "Ukutini", "Uweleni", "Wambaa"
                ]
            },
            {
                name: "Chake Chake District",
                municipals: [
                    "Chachani", "Chanjaani", "Chonga", "Gombani", "Kibokoni",
                    "Kichungwani", "Kilindi", "Kwale", "Madungu", "Matale", "Mbuzini",
                    "Mchanga Mrima", "Mfikiwa", "Mgelema", "Mgogoni", "Michungwani",
                    "Mjini Ole", "Mkoroshoni", "Msingini", "Mvumoni", "Ndagoni",
                    "Ng'ambwa", "Ole", "Pujini", "Shungi", "Tibirinzi", "Uwandani",
                    "Vitongoji", "Wara", "Wawi", "Wesha", "Ziwani"
                ]
            }
        ]
    },
    {
        name: "Unguja North Region",
        districts: [
            {
                name: "Kaskazini A District",
                municipals: [
                    "Banda Kuu", "Bandamaji", "Bwereu", "Chaani Kubwa",
                    "Chaani Masingini", "Chutama", "Fukuchani", "Gamba", "Juga Kuu",
                    "Kandwi", "Kibeni", "Kidombo", "Kidoti", "Kigomani", "Kigunda",
                    "Kikobweni", "Kilimani", "Kilindi", "Kinyasini", "Kipange",
                    "Kisongoni", "Kiungani", "Kivunge", "Matemwe", "Matemwe Kaskazini",
                    "Matemwe Kusini", "Mbuyutende", "Mchangani", "Mchenza Shauri",
                    "Mkokotoni", "Mkwajuni", "Moga", "Mtakuja", "Mto wa Pwani",
                    "Muwanda", "Muwange", "Pale", "Pitanazako", "Potoa",
                    "Pwani Mchangani", "Tazari", "Tumbatu Gomani", "Tumbatu Jongowe",
                    "Uvivini"
                ]
            },
            {
                name: "Kaskazini B District",
                municipals: [
                    "Donge Karange", "Donge Mbiji", "Donge Mtambile", "Donge Pwani",
                    "Donge Vijibweni", "Fujoni", "Kidanzini", "Kilombero", "Kinduni",
                    "Kiombamvua", "Kiongwe Kidogo", "Kisongoni", "Kitope", "Kiwengwa",
                    "Kwagube", "Mafufuni", "Mahonda", "Majenzi", "Makoba", "Mangapwani",
                    "Matetema", "Mbaleni", "Mgambo", "Misufini", "Mkadini", "Mkataleni",
                    "Mnyimbi", "Njia ya Mtoni", "Pangeni", "Upenja", "Zingwezingwe"
                ]
            }
        ]
    },
    {
        name: "Unguja South Region",
        districts: [
            {
                name: "Kusini District",
                municipals: [
                    "Bwejuu", "Dongwe", "Jambiani Kibigija", "Jambiani Kikadini",
                    "Kajengwa", "Kibuteni", "Kijini", "Kiongoni", "Kitogani",
                    "Kizimkazi Dimbani", "Kizimkazi Mkunguni", "Michamvi", "Mtende",
                    "Muungoni", "Muyuni A", "Muyuni B", "Muyuni C", "Mzuri",
                    "Nganani", "Paje", "Tasani"
                ]
            },
            {
                name: "Kati District",
                municipals: [
                    "Bambi", "Binguni", "Bungi", "Charawe", "Cheju", "Chwaka",
                    "Dunga Bweni", "Dunga Kiembeni", "Ghana", "Jendele", "Jumbi",
                    "Kiboje Mkwajuni", "Kiboje Mwembeshauri", "Kidimni", "Kijibwemtu",
                    "Kikungwi", "Koani", "Machui", "Marumbi", "Mchangani", "Mgeni Haji",
                    "Mitakawani", "Miwani", "Mpapa", "Ndijani Mseweni",
                    "Ndijani Mwembepunda", "Ng'ambwa", "Pagali", "Pete", "Pongwe",
                    "Tindini", "Tunduni", "Tunguu", "Ubago", "Ukongoroni", "Umbuji",
                    "Unguja Ukuu Kaebona", "Unguja Ukuu Kaepwani", "Uroa", "Uzi",
                    "Uzini", "Zawiyani"
                ]
            }
        ]
    }
];